/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reports_Cases_By_Client_DescriptionInputs */

const en_reports_cases_by_client_description = /** @type {(inputs: Reports_Cases_By_Client_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Case status per client, with current activity and amounts.`)
};

const pt_br2_reports_cases_by_client_description = /** @type {(inputs: Reports_Cases_By_Client_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Situação dos casos por cliente, com atividade atual e valores.`)
};

/**
* | output |
* | --- |
* | "Case status per client, with current activity and amounts." |
*
* @param {Reports_Cases_By_Client_DescriptionInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const reports_cases_by_client_description = /** @type {((inputs?: Reports_Cases_By_Client_DescriptionInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reports_Cases_By_Client_DescriptionInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_reports_cases_by_client_description(inputs)
	return pt_br2_reports_cases_by_client_description(inputs)
});